import { partners } from '../../data/partners';
import styles from './Partners.module.css';

/**
 * Partners — 두 줄 마퀴, 위/아래 줄이 반대 방향으로 흐릅니다.
 * 같은 로고가 두 줄에 동시에 보이지 않도록 짝수/홀수 인덱스로 분리합니다.
 * 각 카드는 파트너 공식 사이트로 새 탭에서 연결됩니다.
 */
export function Partners() {
  const rowA = partners.filter((_, i) => i % 2 === 0);
  const rowB = partners.filter((_, i) => i % 2 === 1);

  return (
    <section className={styles.section} aria-label="파트너·협력 기관">
      <div className={styles.header}>
        <span className={styles.eyebrow}>Partners</span>
        <h3 className={styles.title}>의료계·법조계가 신뢰하는 팀</h3>
        <p className={styles.note}>법무법인 오킴스가 자문·협력해 온 의료·바이오 파트너</p>
      </div>

      <div className={styles.rows}>
        <MarqueeRow items={rowA} />
        <MarqueeRow items={rowB} reverse />
      </div>
    </section>
  );
}

function MarqueeRow({ items, reverse = false }) {
  // 무한 스크롤을 위해 두 번 이어 붙입니다. 두 번째 사본은 보조용이라 a11y에서 숨깁니다.
  const doubled = items.concat(items);
  return (
    <div className={styles.viewport}>
      <ul className={`${styles.marquee} ${reverse ? styles.marqueeReverse : ''}`}>
        {doubled.map((p, i) => {
          const isClone = i >= items.length;
          return (
            <li key={`${p.no}-${i}`} className={styles.item}>
              <PartnerCard partner={p} isClone={isClone} />
            </li>
          );
        })}
      </ul>
    </div>
  );
}

function PartnerCard({ partner, isClone }) {
  const inner = (
    <>
      <img src={partner.logo} alt={partner.name} className={styles.logo} loading="lazy" />
      <span className={styles.name}>{partner.name}</span>
    </>
  );

  const a11yProps = isClone ? { 'aria-hidden': 'true', tabIndex: -1 } : {};

  if (partner.url) {
    return (
      <a
        href={partner.url}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.card}
        title={partner.name}
        {...a11yProps}
      >
        {inner}
      </a>
    );
  }

  return (
    <div className={styles.card} title={partner.name} {...a11yProps}>
      {inner}
    </div>
  );
}
